exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#chart-area[data-v-051b1cd5]{\n  background-color: white;\n}\n#no-records[data-v-051b1cd5] {\n  height: 90%;\n  display: flex;\n  justify-content: center;\n}\n#no-records span[data-v-051b1cd5]{\n    align-self: center;\n    font-size: x-large;\n    font-weight: bold;\n    color: #1c869a;\n}\n#no-records span i[data-v-051b1cd5]{\n    color: red;\n}\n#loading[data-v-051b1cd5] {\n  height: 90%;\n  display: flex;\n  justify-content: center;\n}\n#loading span[data-v-051b1cd5]{\n  align-self: center;\n  font-size: x-large;\n  font-weight: bold;\n  color: #1c869a;\n}\n", ""]);

// exports
